/**
 * Minimal fetch wrapper. Session lives in an httpOnly cookie, so there is no
 * token handling here — just JSON in, JSON out, and a window event on 401 so
 * the app can drop to the login screen from anywhere.
 */

export class ApiError extends Error {
  constructor(message, status, data) {
    super(message)
    this.status = status
    this.data = data
  }
}

export async function api(path, { method, body } = {}) {
  const res = await fetch(`/api${path}`, {
    method: method || (body !== undefined ? 'POST' : 'GET'),
    headers: body !== undefined ? { 'content-type': 'application/json' } : undefined,
    body: body !== undefined ? JSON.stringify(body) : undefined,
    credentials: 'same-origin',
  })

  if (res.status === 401) {
    window.dispatchEvent(new Event('cdm:unauthorized'))
    throw new ApiError('unauthorized', 401)
  }

  let data = null
  try {
    data = await res.json()
  } catch {
    /* 204s and non-JSON errors */
  }

  if (!res.ok) throw new ApiError(data?.error || res.statusText, res.status, data)
  return data
}

/** Multipart upload — used by the editor's image button. */
export async function upload(path, file) {
  const form = new FormData()
  form.append('file', file, file.name)
  const res = await fetch(`/api${path}`, { method: 'POST', body: form, credentials: 'same-origin' })
  if (!res.ok) {
    const data = await res.json().catch(() => null)
    throw new ApiError(data?.error || 'upload failed', res.status, data)
  }
  return res.json()
}
